// extracted by mini-css-extract-plugin
export default {"card":"card_card__IJQpc"};